import React, { createContext, useEffect, useRef, useState } from "react";

import "react-datepicker/dist/react-datepicker.css";
import { TimesheetHeader } from "./components/timesheetHeader/TimesheetHeader";
import { TimesheetTable } from "./components/timesheetTable/TimesheetTable";
import { TimesheetStyled } from "./Timesheet.styled";
import {
  IComment,
  IStatistic,
  ISummaryEmployee,
  ITask,
  ITimesheet,
  IUser,
} from "../../models";
import { getBearer } from "../../functions/getBearer";
import axios from "axios";
import { getApiLink } from "../../functions/getApiLink";
import { useDispatch, useSelector } from "react-redux";
import { setChosenTimesheet, setTasks, setTimesheet } from "../../storage/toolkit";
import { DownSidebar } from "../../components/downSidebar/DownSidebar";

import { useParams } from "react-router-dom";
import { SetStatistic } from "../../api/SetStatistic";
import { SetTasks } from "../../api/SetTasks";
import { SummaryExportTableTimesheet } from "../summary/components/SummaryExportTableTimesheet";

interface ITimesheetProps {}

export const BlockToEdit: any = createContext(null);
export const BlockToDuplicate: any = createContext(null);
export const FixedTopEdit: any = createContext(null);
export const AmountStatistic: any = createContext(null);

export const Timesheet: React.FC<ITimesheetProps> = () => {
  const dispatch = useDispatch();

  const { timesheetId }: any = useParams();

  const user: IUser = useSelector((state: any) => state.toolkit.user);
  const taskList: ITask[] = useSelector((state: any) => state.toolkit.tasks);
  const chosenTimesheet: ITimesheet = useSelector(
    (state: any) => state.toolkit.chosenTimesheet
  );
  const timesheetStatistic: IStatistic = useSelector(
    (state: any) => state.toolkit.timesheetStatistic
  );
  const summaryEmployees: ISummaryEmployee = useSelector(
    (state: any) => state.toolkit.summaryEmployees
  );
  const timesheet: ITimesheet[] = useSelector(
    (state: any) => state.toolkit.timesheet
  );

  const [itemToEdit, setItemToEdit] = useState<ITask>();
  const [itemToDuplicate, setItemToDuplicate] = useState<ITask>();
  const [isOpenDownSidebar, setIsOpenDownSidebar] = useState(false);
  const [statistic, setStatistic] = useState<IStatistic | undefined>();
  const [isLoad, setIsLoad] = useState(false);
  const [isWindowMobile, setIsWindowMobile] = useState(false);
  const [comments, setComments] = useState<IComment[]>([]);

  useEffect(() => {
    if (timesheetId) {
      window.scrollTo(0, 0);
    }
    if (
      !!timesheetId ||
      !chosenTimesheet ||
      !Object.keys(chosenTimesheet)?.length
    )
      return;

    getBearer("get");
    axios
      .get(
        getApiLink(
          `/api/timesheet/tasks/?timesheet_id=${
            timesheetId ?? chosenTimesheet?.id
          }`
        )
      )
      .then(({ data }) => {
        dispatch(setTasks(data));
      });

    if (!timesheetId && !chosenTimesheet?.id) return;

    SetStatistic(dispatch, timesheetId ?? chosenTimesheet?.id);
  }, [chosenTimesheet, timesheetId]);

  useEffect(() => {
    if (timesheetId) return;
    if (!user?.id) return;

    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    getBearer("get");
    axios
      .get(
        getApiLink(
          `/api/timesheet/tasks/?month=${currentMonth}&year=${currentYear}&user_id=${user.id}`
        )
      )
      .then(({ data }) => {
        dispatch(setTasks(data));
      })
      .catch(() => {});

    getBearer("get");
    axios
      .get(getApiLink(`/api/timesheet/my/?year=${currentYear}`))
      .then(({ data }) => {
        dispatch(setTimesheet(data));
      })
      .catch(() => {});
  }, [user?.id]);

  useEffect(() => {
    if (summaryEmployees?.all?.length && timesheetId) {
      const chosenTimesheet =
        summaryEmployees.all.filter((item) => item.id === timesheetId)[0] ??
        summaryEmployees.favourite.filter((item) => item.id === timesheetId)[0];

      dispatch(setChosenTimesheet(chosenTimesheet));

      getBearer("get");
      axios
        .get(getApiLink(`/api/timesheet/tasks/?timesheet_id=${timesheetId}`))
        .then(({ data }) => {
          dispatch(setTasks(data));
        });

      SetStatistic(dispatch, timesheetId);
    }
  }, [summaryEmployees]);

  useEffect(() => {
    if (!chosenTimesheet?.id) return;

    if (timesheetId === undefined && chosenTimesheet?.user?.id !== user?.id) {
      // SetTimesheet(dispatch)
      SetTasks(dispatch, chosenTimesheet?.id);
    }

    setIsWindowMobile(window.innerWidth < 576);
  }, []);

  useEffect(() => {
    if (isLoad) return;

    setTimeout(() => {
      setIsLoad(true);
    }, 1000);
  }, [taskList, isLoad]);

  useEffect(() => {
    if (!timesheetStatistic) return;
    setStatistic(timesheetStatistic);
  }, [timesheetStatistic]);

  useEffect(() => {
    if (!chosenTimesheet?.id) return;

    getBearer("get");
    axios
      .get(getApiLink(`/api/comment/?timesheet_id=${chosenTimesheet.id}`))
      .then(({ data }) => {
        setComments(data);
      });
  }, [chosenTimesheet]);

  const [isFixedEditBlock, setIsFixedEditBlock] = useState(false);
  const [amountStatistic, setAmountStatistic] = useState(0);

  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const header = section.querySelector('.section-table__header');
    if (!header) return;
    const observer = new ResizeObserver(() => {
      section.style.setProperty('--sticky-table-head-top', `${header.getBoundingClientRect().height}px`);
    });
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  return (
    <BlockToDuplicate.Provider value={setItemToDuplicate}>
      <AmountStatistic.Provider value={setAmountStatistic}>
        <FixedTopEdit.Provider value={setIsFixedEditBlock}>
          <BlockToEdit.Provider value={setItemToEdit}>
            <TimesheetStyled ref={sectionRef}
              style={{
                paddingBottom: isOpenDownSidebar
                  ? "270px"
                  : isWindowMobile
                  ? "60px"
                  : "80px",
              }}
              className={`section-table timesheet-table${
                isFixedEditBlock ? " fixed-edit-block" : ""
              }`}
            >
              <TimesheetHeader
                itemToDuplicate={itemToDuplicate}
                setItemToDuplicate={setItemToDuplicate}
                isFixedEditBlock={isFixedEditBlock}
                itemToEdit={itemToEdit}
              />

              {chosenTimesheet?.id && (
                <TimesheetTable
                  itemToEdit={itemToEdit}
                />
              )}
            </TimesheetStyled>

            <SummaryExportTableTimesheet/>

            <DownSidebar
              comments={comments}
              amountStatistic={amountStatistic}
              setComments={setComments}
              type={"timesheet"}
              statisticAllAmount={
                statistic?.all_hours ?? timesheetStatistic.all_hours
              }
              statisticAllElements={
                statistic?.tasks ?? timesheetStatistic.tasks
              }
              setIsOpenDownSidebar={setIsOpenDownSidebar}
            />
          </BlockToEdit.Provider>
        </FixedTopEdit.Provider>
      </AmountStatistic.Provider>
    </BlockToDuplicate.Provider>
  );
};
